import { render, staticRenderFns } from "./AddSalaryCommissionContent.vue?vue&type=template&id=1c640543"
import script from "./AddSalaryCommissionContent.vue?vue&type=script&lang=js"
export * from "./AddSalaryCommissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports